import { createPathType, MomentRoute } from '@moment/routes/types.ts';
import { TripodLivePreview } from '@moment/layouts/TripodLivePreview/LivePreview.tsx';
import { TabbedSeenUIDsProvider } from '@moment/layouts/TabContainerLayout/TabbedSeenUIDsContext';
import { FragmentInstance, LayoutItem } from '@moment/shared-code/widgets.tsx';
import { FragmentWithRevisions } from '@/tripod/views/FeedFragmentEditorView.tsx';

export const TRIPOD_LIVE_PREVIEW: MomentRoute<Record<string,string>, void> = {
  path: createPathType<Record<string,string>>('tripod-live-preview/:revision'),
  title: 'Moment | Tripod preview',
  description: 'Moment | Tripod preview page',
  // Wrap the standalone preview page in the provider.
  element: (
    <TabbedSeenUIDsProvider>
      <TripodLivePreview pageIdFromRoute={true} />
    </TabbedSeenUIDsProvider>
  ),
  serverHydrate: async (params) => {
    if (import.meta.env.SSR) {
      // dynamic import is to avoid client side trying to import db services.
      const { databases } = await import('@moment/db/db-services.ts');
      const { tripod } = databases;

      const revision = await tripod.getRevisionById(params.revision);
      if (!revision) {
        return null;
      }

      const layoutItems = revision.layoutContent as LayoutItem[];
      const fragmentIds = [...new Set(
        layoutItems
          .filter((item): item is FragmentInstance => item.itemType === 'fragment')
          .map(item => item.fragmentId)
      )];

      if (fragmentIds.length === 0) {
        return { revision, fragments: {} };
      }

      const fragmentPromises = fragmentIds.map(id => tripod.getFragmentWithRevisions(id));
      const fragmentResults = await Promise.all(fragmentPromises);

      const fragmentsMap = fragmentResults.reduce((acc, frag) => {
        if (frag) {
          acc[frag.id] = frag;
        }
        return acc;
      }, {} as Record<string, Partial<FragmentWithRevisions>>);

      return { revision, fragments: fragmentsMap };
    } else {
      return {}
    }
  }
};
